import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { Suspense } from 'react';
import LoadingIndicator from 'components/LoadingIndicator';
import LoginPage from './Login';
import { UserContextProvider } from 'contexts/userContext';
import ProtectedRoutes from 'components/ProtectedRoutes';
import SelfEvaluationPage from './Self';
import TeamPage from './Team';
import ReporteeDetailsPage from './Team/ReporteeDetails';
import SelfEvaluationFormPage from './Self/SelfEvaluationForm';
import Dashboard from './Dashboard';
import CreateEmployee from './Users/CreateEmployee';
import RemoveEmployee from './Users/UpdateEmployee';
import ReporteeEvaluationFormPage from './Team/ReporteeEvaluationForm';
import AdminReportsPage from './Admin/AdminReports';
import HODReportsPage from './HODReports';
import SelfPromotionalQnA from './Self/QnA';
import ReporteePromotionQnA from './Team/ReporteePromotionQnA';
import AllEmployees from './Admin/AllEmployees';
import ObjectiveYearSettings from './ObjectiveYearSettings';

const App = () => {
  return (
    <Router>
      <Suspense fallback={<LoadingIndicator />}>
        <UserContextProvider>
          <Routes>
            <Route element={<LoginPage />} path="/login" />
            <Route element={<ProtectedRoutes />}>
              <Route element={<Dashboard />} path="/" />
              <Route element={<SelfEvaluationPage />} path="/self" />
              <Route element={<SelfEvaluationFormPage />} path="/self/edit" />
              <Route element={<SelfPromotionalQnA />} path="/self/promotion-form" />
              <Route element={<TeamPage />} path="/team" />
              <Route element={<ReporteeDetailsPage />} path="/team/:userId" />
              <Route element={<ReporteePromotionQnA />} path="/team/:userId/promotion-form" />
              <Route element={<ReporteeEvaluationFormPage />} path="/team/:userId/edit" />
              <Route element={<HODReportsPage />} path="/hod-reports" />
              <Route element={<CreateEmployee />} path="/users/create-user" />
              <Route element={<RemoveEmployee />} path="/users/remove-user" />
              <Route element={<AdminReportsPage />} path="/admin-reports" />
              <Route element={<AllEmployees />} path="/admin-users" />
              <Route element={<ObjectiveYearSettings />} path="/year-settings" />
            </Route>
          </Routes>
        </UserContextProvider>
      </Suspense>
    </Router>
  );
};

export default App;
